/**
 * bz-cart.js: behaviour for sections/bz-cart.liquid (quantity steppers / line-item qty handling).
 * Scoped to the [data-bz-cart] wrapper. Loaded with defer.
 */
(function(){
  // External defer script: find the cart wrapper directly (was document.currentScript.closest(...)).
  var scope = document.querySelector('[data-bz-cart]') || document;
  var form = scope.querySelector('#bz-cart-form');
  function inputMax(input){
    var m = parseInt(input.getAttribute('max'), 10);
    return isNaN(m) ? null : m;
  }
  function inventoryMessage(limit){
    if (limit == null || isNaN(limit)) return 'Quantity updated.';
    if (limit <= 0) return 'Sold out - quantity updated.';
    return 'Only ' + limit + ' available - quantity updated.';
  }
  function showQuantityFeedback(input, limit){
    var message = inventoryMessage(limit);
    if (window.bzInventoryGuard) {
      if (typeof window.bzInventoryGuard.showInlineError === 'function') {
        window.bzInventoryGuard.showInlineError(input, message);
      }
      if (typeof window.bzInventoryGuard.showToast === 'function') {
        window.bzInventoryGuard.showToast(message);
      }
    }
    input.classList.add('is-capped');
    var row = input.closest && input.closest('.bz-product-qty__row');
    if (row) row.classList.add('is-capped');
    clearTimeout(input._bzCapTimer);
    input._bzCapTimer = setTimeout(function(){
      input.classList.remove('is-capped');
      if (row) row.classList.remove('is-capped');
    }, 900);
  }
  function clampLine(input, v){
    if (v < 0) v = 0;
    var m = inputMax(input);
    if (m != null && v > m) v = m;
    return v;
  }
  function submitCartForm(){
    if (form) form.submit();
  }
  function guardLine(input, requested){
    requested = clampLine(input, requested);
    if (!window.bzInventoryGuard || typeof window.bzInventoryGuard.clampCartQuantity !== 'function') {
      input.value = requested;
      submitCartForm();
      return;
    }
    window.bzInventoryGuard.clampCartQuantity({
      quantity: requested,
      line: input.getAttribute('data-line'),
      variantId: input.getAttribute('data-bz-variant-id'),
      handle: input.getAttribute('data-bz-product-handle'),
      sourceElement: input
    }).then(function(result){
      input.value = result && typeof result.quantity === 'number' ? result.quantity : requested;
      submitCartForm();
    }).catch(function(){
      var fallback = clampLine(input, parseInt(input.defaultValue || input.value, 10) || 0);
      input.value = fallback;
    });
  }
  function initDiscountFlash(){
    var flash = scope.querySelector('[data-bz-discount-flash]');
    if (!flash) return;
    var attempted = '';
    try {
      var params = new URLSearchParams(window.location.search || '');
      attempted = params.get('discount_applied') || params.get('discount') || params.get('discount_code') || '';
    } catch (e) {}
    if (attempted) {
      var active = (flash.getAttribute('data-active-discounts') || '').toUpperCase().split('|');
      if (active.indexOf(attempted.toUpperCase()) === -1) flash.hidden = false;
    }
    var dismiss = flash.querySelector('[data-bz-discount-dismiss]');
    if (dismiss) dismiss.addEventListener('click', function(){ flash.hidden = true; });
  }
  initDiscountFlash();
  var steppers = scope.querySelectorAll('[data-bz-cart-step]');
  for (var i = 0; i < steppers.length; i++){
    (function(btn){
      btn.addEventListener('click', function(){
        if (btn.disabled) return;
        var line = btn.getAttribute('data-line');
        var input = scope.querySelector('input[data-bz-cart-qty][data-line="' + line + '"]');
        if (!input || input.disabled) return;
        var step = parseInt(btn.getAttribute('data-bz-cart-step'), 10) || 1;
        var current = parseInt(input.value, 10) || 0;
        var max = inputMax(input);
        // Don't snap a value that's already above max downward when the user
        // tries to increase; let them only shrink via the − button.
        if (step > 0 && max != null && current >= max) {
          showQuantityFeedback(input, max);
          return;
        }
        var next = clampLine(input, current + step);
        if (next === current) {
          if (step > 0 && max != null) showQuantityFeedback(input, max);
          return;
        }
        input.value = next;
        guardLine(input, next);
      });
    })(steppers[i]);
  }
  var qtyInputs = scope.querySelectorAll('[data-bz-cart-qty]');
  for (var j = 0; j < qtyInputs.length; j++){
    (function(input){
      input.addEventListener('change', function(){
        if (input.disabled) return;
        var requested = parseInt(input.value, 10) || 0;
        var clamped = clampLine(input, requested);
        if (clamped !== requested) showQuantityFeedback(input, inputMax(input));
        input.value = clamped;
        guardLine(input, clamped);
      });
    })(qtyInputs[j]);
  }
})();
